import React, { memo } from 'react';

import { Box } from '@mui/material';
import AutocompleteCDS from '@sharedCR/coreDesignSystem/form/AutocompleteCDS';
import DateFieldCDS from '@sharedCR/coreDesignSystem/form/DateFieldCDS';
import TextFieldCDS from '@sharedCR/coreDesignSystem/form/TextFieldCDS';
import PropTypes from 'prop-types';

import { FilterFieldKind } from '../../RunHistoryCard.config';
import { filterFieldStyles } from '../../RunHistoryCard.styles';

const EMPTY_OPTIONS = [];

const FilterField = ({
  field,
  options = EMPTY_OPTIONS,
  value = null,
  onChange,
  dataTestId = null,
  placeholder = null,
}) => (
  <Box sx={filterFieldStyles}>
    {field.kind === FilterFieldKind.TEXT && (
      <TextFieldCDS
        dataTestId={dataTestId}
        label={field.label}
        name={field.key}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
      />
    )}
    {field.kind === FilterFieldKind.AUTOCOMPLETE && (
      <AutocompleteCDS
        dataTestId={dataTestId}
        label={field.label}
        name={field.key}
        options={options}
        value={value}
        onChange={onChange}
      />
    )}
    {field.kind === FilterFieldKind.DATE && (
      <DateFieldCDS
        dataTestId={dataTestId}
        label={field.label}
        name={field.key}
        value={value}
        onChange={onChange}
      />
    )}
  </Box>
);

FilterField.propTypes = {
  field: PropTypes.shape({
    key: PropTypes.string.isRequired,
    kind: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
  }).isRequired,
  onChange: PropTypes.func.isRequired,
  dataTestId: PropTypes.string,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      value: PropTypes.string,
    }),
  ),
  placeholder: PropTypes.string,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.shape({
      label: PropTypes.string,
      value: PropTypes.string,
    }),
  ]),
};

export default memo(FilterField);
